<mat-form-field class="example-full-width" appearance="outline">
  <mat-label>{{ label }}</mat-label>
  <input matInput [formControl]="control" [matAutocomplete]="auto" />
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayProperty">
    <mat-option
      title="{{ bank.description }}"
      *ngFor="let bank of filteredOptions | async | async"
      [value]="bank"
    >
      {{ bank.description }}
    </mat-option>
    <!-- <mat-option *ngIf="(filteredOptions | async | async)?.length === 0" [value]="control.value">
        Создать {{control.value}}
      </mat-option> -->
  </mat-autocomplete>
</mat-form-field>
